import createCSVValueGetter from './createCSVValueGetter';

const creativeAdIdFormatter = ({ rowData }) => {
    const { isCreativeLibrary, adId: linkId, id: instructionId } = rowData;
    return isCreativeLibrary ? linkId : instructionId;
};

export const csvAdIdValueGetter = createCSVValueGetter(creativeAdIdFormatter);
